import { dispatch } from 'store'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { IAudioItem } from 'types/audio'
import { IMediaItem } from 'types/media'

export const DEFAULT_VOLUME = 50

export const handleMediaVolumeChange = (
  volume: number,
  items: IMediaItem[]
) => {
  items.forEach(item => {
    if (item) {
      dispatch(
        projectDataThunks.updateMediaItem({
          id: item.id,
          updates: { meta: { ...item.meta, volume } }
        })
      )
    }
  })
}

export const handleAudioVolumeChange = (
  volume: number,
  items: IAudioItem[]
) => {
  items.forEach(item => {
    if (item) {
      dispatch(
        projectDataThunks.updateAudioItems({
          ids: [item.id],
          updates: { volume }
        })
      )
    }
  })
}

export const getActiveMediaVolume = (item?: IMediaItem | IAudioItem) => {
  if (!item) {
    return DEFAULT_VOLUME
  }
  return ('meta' in item ? item.meta.volume : item.volume) ?? DEFAULT_VOLUME
}
